// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"2df4c225","640":"1e9506a7"}[chunkId] + ".chunk.js";
};